import { WE_CRM_URL } from "../../../config/api";

const getBaseUrl = (overrideUrl) => {
  return (overrideUrl || WE_CRM_URL || "https://aistartupdoctor.com/api").replace(/\/$/, "");
};

/**
 * Fetch pending client onboard requests from WE-CRM / Startup Doctor
 */
export async function getClientOnboardRequests({ weCrmUrl, companyId, companyCode, search } = {}) {
  const base = getBaseUrl(weCrmUrl);
  const params = new URLSearchParams();
  if (companyId) params.set("company_id", companyId);
  if (companyCode) params.set("companyCode", companyCode);
  if (search) params.set("search", search);

  const queryStr = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${base}/users/client-onboard-requests${queryStr}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || `Failed to fetch onboard requests (${response.status})`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : data?.requests || data?.items || [];
}

/**
 * Fetch public managers from Startup Doctor
 */
export async function getStartupDoctorManagers({ weCrmUrl, companyId } = {}) {
  const base = getBaseUrl(weCrmUrl);
  const params = new URLSearchParams();
  if (companyId) params.set("company_id", companyId);

  const queryStr = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${base}/users/public/managers${queryStr}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || `Failed to fetch managers (${response.status})`);
  }

  return response.json();
}

/**
 * Register client account in Startup Doctor
 */
export async function registerStartupDoctorClient({ weCrmUrl, payload } = {}) {
  const base = getBaseUrl(weCrmUrl);
  const response = await fetch(`${base}/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Registration failed (${response.status})`);
  }

  return data;
}

/**
 * Approve Entity Request in Startup Doctor
 */
export async function approveStartupDoctorEntity({ weCrmUrl, userId, requestId } = {}) {
  const base = getBaseUrl(weCrmUrl);
  const response = await fetch(`${base}/auth/approve-entity`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId,
      requestId,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Failed to approve entity (${response.status})`);
  }

  return data;
}
